module.exports = __webpack_public_path__ + "img/icon-plus.8d1c8b31.svg";